import { Select } from '@nv/basic-components'
import { useTranslation } from 'react-i18next'
import styles from './SelectRows.module.scss'

export const SelectRows = ({ newNumRowsPerPage, setNewNumRowsPerPage, onNumRowsChange }) => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <span id='rows-per-page' className={styles['select-rows']}>
        {t('main.rowsPerPage')}
      </span>
      <Select
        field='rowsPerPage'
        aria-labelledby={'rows-per-page'}
        value={newNumRowsPerPage}
        onChange={(val) => {
          setNewNumRowsPerPage(val.value)
          onNumRowsChange?.(val.value)
        }}
        options={[
          { value: 10, label: 10 },
          { value: 20, label: 20 },
          { value: 50, label: 50 },
          { value: 100, label: 100 },
        ]}
        classes={{ container: styles['select-container'], select: styles['select-select'], content: styles['select-content'] }}
      />
    </div>
  )
}
